import { render, staticRenderFns } from "./AddCollaborator.vue?vue&type=template&id=84d44738&scoped=true"
import script from "./AddCollaborator.vue?vue&type=script&lang=js"
export * from "./AddCollaborator.vue?vue&type=script&lang=js"
import style0 from "./AddCollaborator.vue?vue&type=style&index=0&id=84d44738&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d44738",
  null
  
)

export default component.exports